import React, { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import TradeOffers from '../components/TradeOffers';

function TradePage() {
    const { userData, globalCards } = useContext(UserContext);
    if (!userData || !globalCards) return <Typography>Loading...</Typography>;

    return (
        <>
            <Typography variant="h4" gutterBottom>
                Welcome, {userData.username}
            </Typography>
            <TradeOffers />
        </>
    );
}

export default TradePage;
